import React from "react";
import { Drawer as AntDrawer } from "antd";
import "./drawer.css";

export const Drawer = ({
  children,
  open,
  onClose,
  placement,
  // Both names, because both arrive: antd 6 calls it `size`, and callers written
  // against the older API pass `width`. Taken out of `rest` on purpose — left in
  // it, a caller's `size` would land after the computed one below and quietly
  // win, which is how a left-hand drawer could stop being 600 wide.
  width,
  size,
  ...rest
}) => {
  return (
    <AntDrawer
      className="lf-drawer"
      open={open}
      closable={false}
      onClose={onClose}
      placement={placement}
      {...rest}
      size={placement === "left" ? 600 : size ?? width ?? 800}
    >
      <div className={"lf-drawer__content"}>{children}</div>
    </AntDrawer>
  );
};
